export default __webpack_public_path__ + "static/media/knowing-hands.81d1cefd.svg";